// First we need to import axios.js
import axios from 'axios';
import { firebaseAuthServices } from '../firebaseAuth';
// Next we make an 'instance' of it
const instance = axios.create({
    // baseURL: 'http://localhost:5000/',
    // baseURL: 'https://edca-203-175-78-24.ngrok.io/',
    baseURL: process.env.REACT_APP_API_URL,
});

instance.interceptors.response.use(
    (response) => response,
    async (error) => {
        // Handle auth
        if (error?.response?.status === 401) {
            firebaseAuthServices.signOut();
            // const token = await firebaseAuthServices.refrestToken()
            // setUserIdToken(token)
        }

        // Normalize error shape to include status and axios-like response for downstream checks
        if (error?.response) {
            const data = error.response.data || {};
            const normalized = Object.assign(
                new Error(data.message || `Request failed with status ${error.response.status}`),
                {
                    ...data,
                    status: error.response.status,
                    response: {
                        status: error.response.status,
                        data: error.response.data,
                        headers: error.response.headers,
                    },
                }
            );
            throw normalized;
        }

        console.error('Network connection error. Please check you internet connection or try to log in again.');
        throw new Error('Network connection error. Please check you internet connection or try to log in again.');
    }
);

instance.defaults.headers.post['Content-Type'] = 'application/json';
// instance.defaults.headers.get['Content-Type'] = 'application/json';

// instance.defaults.headers['Content-Type'] = 'application/json';

// Where you would set stuff like your 'Authorization' header, etc ...

//instance.defaults.headers.common['Authorization'] = 'AUTH TOKEN FROM instance';

// Also add/ configure interceptors && all the other cool stuff

//instance.interceptors.instance...
/**
 * attaches the logged in user's firebase `idToken` to the authentication header
 */
export const setUserIdToken = (idtk: string) => {
    instance.defaults.headers.common['Authorization'] = `Bearer ${idtk}`;
};
export default instance;
